import { __assign } from "tslib";
import React from 'react';
import MinimalDumbo from '../../../../DeviationViews/Dumbo/EditorDumbo';
import s from './Journal.scss';
var JournalThumbReactView = function (props) { return (React.createElement("div", { className: s['root'], style: { width: props.width, height: props.height } },
    React.createElement(MinimalDumbo, __assign({}, props)))); };
JournalThumbReactView.displayName = 'JournalThumbReactView';
export default JournalThumbReactView;
//# sourceMappingURL=Journal.js.map